var map = {
	"./tasks/orders/routes.children.js": 4665,
	"./tasks/part_numbers/routes.children.js": 5013,
	"./tasks/setup/categories/routes.children.js": 149,
	"./tasks/setup/types/routes.children.js": 1206,
	"./tasks/setup/vendors/routes.children.js": 7488,
	"./tasks/system/configurations/routes.children.js": 9600,
	"./tasks/system/module-tasks/routes.children.js": 689,
	"./tasks/system/user-groups/routes.children.js": 6228,
	"./tasks/users/routes.children.js": 7098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9196;